/** "harbor-test.com" → "Harbor-test"; your own domain → your workspace's name; a personal address → null. */
export function companyOf(
  domain: string | null,
  home: { domain: string | null; name: string } | null,
): string | null {
  if (!domain) return null;
  const d = domain.toLowerCase();
  if (home?.domain && d === home.domain.toLowerCase()) return home.name;
  const stem = d.split('.')[0] || d;
  return stem.charAt(0).toUpperCase() + stem.slice(1);
}

export const domainOf = (email: string): string =>
  email.slice(email.indexOf('@') + 1).toLowerCase();
